<template>
  <div class="online-appointment-thank-you-view row pb-5 text-primary">
    <div class="col-12 text-center">
      <p class="mt-4 small font-weight-bold">
        {{ $t('thank_you.header') }}
      </p>
      <div v-if="appointment?.start" class="mb-3 font-weight-normal">
        {{ toFormattedDate(appointment.start, $t('visitor_data.appointment_full_date_format')) }}
      </div>
      <div class="thank-you-content-wrap">
        <div class="small my-5 font-weight-normal">
          <div class="font-weight-bold mb-3">
            {{ $t('thank_you.appointment_info') }}
          </div>

          <ul class="appointment-info-list">
            <li>{{ $t('thank_you.appointment_info_items.documents') }}</li>
            <li>{{ $t('thank_you.appointment_info_items.health_card') }}</li>
            <li>{{ $t('thank_you.appointment_info_items.medication') }}</li>
            <li>{{ $t('thank_you.appointment_info_items.referral') }}</li>
          </ul>

        </div>

        <a class="btn btn-lg btn-primary my-4 action-button" @click.prevent="restart">
          {{ $t('thank_you.restart') }}
        </a>
      </div>

    </div>
  </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex'
import dateFormats from 'pixelstein-vue-app-package/src/mixins/date-formats'

export default {
  name: 'ThankYou',
  mixins: [dateFormats],
  props: {
    appointmentTypeId: { type: String, default: null },
    locationId: { type: String, default: '' },
    appointmentId: { type: String, default: '' }
  },
  computed: {
    ...mapState({
      appointment: state => state.Api.Appointments.current,
      location: state => state.Api.Locations.current
    }),
  },
  methods: {
    ...mapMutations({
      setQuestionPath: 'setQuestionPath'
    }),
    restart () {
      this.setQuestionPath([])
      this.$router.push('/').catch(console.error)
    }
  }
}
</script>

